import { Upload, RefreshCw } from 'lucide-react';
import { useTranslations } from 'use-intl';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { isInvoiceUploadEnabled } from '@/config/features';

interface PageHeaderActionsProps {
  onRefresh: () => void | Promise<void>;
  refreshing: boolean;
  showUpload?: boolean;
}

const PageHeaderActions = ({
  onRefresh,
  refreshing,
  showUpload = true
}: PageHeaderActionsProps) => {
  const navigate = useNavigate();
  const t = useTranslations('consultantTransactions.headerActions');

  const handleUploadClick = () => {
    navigate('/upload');
  };

  return (
    <div className="flex gap-2">
      {showUpload && isInvoiceUploadEnabled() && (
        <Button
          variant="outline"
          onClick={handleUploadClick}
          className="flex items-center gap-2"
        >
          <Upload size={18} />
          {t('upload')}
        </Button>
      )}
      <Button
        variant="outline"
        onClick={onRefresh}
        disabled={refreshing}
        className="flex items-center gap-2"
      >
        <RefreshCw size={18} className={refreshing ? "animate-spin" : ""} />
        {t('refresh')}
      </Button>
    </div>
  );
};

export default PageHeaderActions;